module.exports = __webpack_public_path__ + "img/cooperation16.fb0c2ec7.png";